module.exports = __webpack_public_path__ + "img/portal_2.df87091a.gif";